const jigsawThemeConfig = {
  cookieBotId: "b66ede31-4817-4c2b-a4dd-e671cc93f4e0",
  login: "Login",
  showLogo: false,
  hasBackgrounds: false,
  contactEmail: "support@whycatcher.com",
  privacy: "https://www.jigsaw-research.co.uk/privacy-policy/",
  communityName: "Whycatcher | Participant portal",
  enableDashboardStats: true,
  showUserSettingsPayment: true,
  participantMenu: [{
    title: "Settings",
    url: "theme-participant-user-settings",
    icon: "fa-cog",
  }],
  sideMenu: {
    dashboardEnabled: true,
    dashboardName: "Task Dashboard",
    aboutEnabled: false,
    FAQEnabled: false,
    newsEnabled: false,
    contactEnabled: true
  },
  images: {
    aboutImage: [
      {
        url: "/themes/app/pages/hero/about.jpg",
      },
    ],
  },
  tinyMce: {
    content_style:
      "body { color: #7c7c7c; font-size: 14px; font-family: Arial; }",
  },
  dailyCall: {
    style: {
      accent: "#045a69", // Main theme color. Used for primary actions and keyboard focus.
      accentText: '#ffffff', // Text color rendered on accent.
      background: '#fbfbfb', // Background color.
    },
  },
};

export default jigsawThemeConfig;
